if (!customElements.get('quick-add-card')) {
  customElements.define(
    'quick-add-card',
    class QuickAddCard extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.quick-add-btn');
        this.variantId = this.button?.dataset.variantId;
      }

      connectedCallback() {
        if (!this.button || !this.variantId) return;
        this.button.addEventListener('click', this.onAddClick.bind(this));
      }

      onAddClick() {
        if (this.button.getAttribute('aria-disabled') === 'true') return;

        this.button.setAttribute('aria-disabled', true);
        this.button.classList.add('loading');

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        const body = JSON.stringify({
          items: [{ id: this.variantId, quantity: 1 }],
          sections: cart ? cart.getSectionsToRender().map((section) => section.id) : [],
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, {
          ...fetchConfig(),
          body,
        })
          .then((response) => response.json())
          .then((response) => {
            this.button.removeAttribute('aria-disabled');
            this.button.classList.remove('loading');

            if (response.status) {
              console.error(response.message || response.description);
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'quick-add-card',
              productVariantId: this.variantId,
              cartData: response,
            });

            if (cart) {
              cart.setActiveElement?.(document.activeElement);
              if (response.sections) cart.renderContents({ sections: response.sections });
              cart.open?.();
            }
          })
          .catch((error) => {
            this.button.removeAttribute('aria-disabled');
            this.button.classList.remove('loading');
            console.error(error);
          });
      }
    },
  );
}
